import { InjectionToken } from '@angular/core';

export let CUSTOM_CHIP_DATA: InjectionToken<string> = new InjectionToken<string>('CustomChipData');
